import React, { useState } from 'react';
import Colors from '../../../utils/colors';
import { Check } from 'lucide-react';

export enum CheckBoxSeverity {
  SUCCESS,
  DANGER,
  WARNING,
  LIGHT_APPROVE,
}
export interface CustomCheckboxDatamodel {
  severity: CheckBoxSeverity;
  checked: boolean;
  onChange: (checked: boolean) => any;
  disabled?: boolean;
}
export const ColorfulCheckbox: React.FC<CustomCheckboxDatamodel> = ({
  severity,
  checked,
  onChange,
  disabled = false,
}) => {
  const [isHovered, setIsHovered] = useState(false);

  const getColor = () => {
    switch (severity) {
      case CheckBoxSeverity.SUCCESS:
        return Colors.approveText;
      case CheckBoxSeverity.WARNING:
        return Colors.warningText;
      case CheckBoxSeverity.DANGER:
        return Colors.dangerText;
      case CheckBoxSeverity.LIGHT_APPROVE:
        return Colors.lightApprove;
    }
  };

  const getBorderColor = () => {
    if (disabled) {
      return '#e5e7eb';
    }
    return isHovered || checked ? getColor() : '#d1d5db';
  };

  const getBackgroundColor = () => {
    if (disabled) {
      return checked ? '#d1d5db' : '#f3f4f6';
    }
    return checked ? getColor() : 'white';
  };

  const checkboxStyle = {
    width: '22px',
    height: '22px',
    borderRadius: '6px',
    cursor: disabled ? 'not-allowed' : 'pointer',
    border: `2px solid ${getBorderColor()}`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: getBackgroundColor(),
    opacity: disabled ? 0.6 : 1,
    transition: 'background-color 0.01s ease',
  };

  const iconStyle = {
    color: 'white',
  };

  return (
    <div
      style={checkboxStyle}
      onClick={() => {
        if (disabled) {
          return;
        }
        onChange(!checked);
      }}
      onMouseEnter={() => {
        if (!disabled) {
          setIsHovered(true);
        }
      }}
      onMouseLeave={() => setIsHovered(false)}
    >
      {checked && <Check style={iconStyle} size={16} />}
    </div>
  );
};
